var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { QueryClient } from "react-query";
import { getViewAsLibraryId } from "./viewAsLibrary";
export var hasHttpResponse = function (error) {
    return typeof error === "object" &&
        error !== null &&
        "response" in error &&
        error.response instanceof Response;
};
export var isClientError = function (error) {
    return hasHttpResponse(error) &&
        error.response.status >= 400 &&
        error.response.status < 500;
};
export var isForbidden = function (error) {
    return hasHttpResponse(error) && error.response.status === 403;
};
/**
 * A 4xx answer is deterministic, so retrying it only delays the error the user needs to see.
 */
export var retryUnlessClientError = function (failureCount, error) { return !isClientError(error) && failureCount < 3; };
export var getHeaders = function (additionalHeaders) {
    if (additionalHeaders === void 0) { additionalHeaders = {}; }
    var headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
    };
    var viewAsLibraryId = getViewAsLibraryId();
    if (viewAsLibraryId) {
        headers["X-View-As-Library"] = viewAsLibraryId;
    }
    return __assign(__assign({}, headers), additionalHeaders);
};
export var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0,
            cacheTime: 0,
            refetchOnWindowFocus: true,
            refetchOnMount: true,
        },
    },
});
